import Vue from 'vue'
import Cookies from "js-cookie";

let languageList = [{
  key: "zh-CN",
  name: "中文简体"
}, {
  key: "en",
  name: "English"
}];
export default {
  userInfo: undefined,
  menuList: undefined,
  buttonPermissionMap: undefined,
  isSupperAdmin() { // 判断登录用户是否是管理员
    const userInfo = this.getUserInfo();
    if (userInfo.roles) {
      for (let i = 0; i < userInfo.roles.length; i++) {
        if (userInfo.roles[i].roleKey == "supperAdmin") {
          return true;
        }
      }
    }
    return false;
  },
  intNumberFormat(num, split = ',') {
    return (num + '').replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, '$1' + split)
  },
  priceFormat(money, fixNum = 2) {
    if (!money) return '0.00'
    const moneyStr = (money - 0).toFixed(fixNum)
    const [int, float] = moneyStr.split('.')
    return this.intNumberFormat(int) + '.' + float
  },
  getUserRoleId() {
    try {
      const userInfo = this.getUserInfo();
      const roles = userInfo.roles;
      for (let index = 0; index < roles.length; index++) {
        return roles[index].roleId ;
      }
    } catch (error) {
      return "";
    }
  },
  setUserInfo(userInfo) { //设置用户信息
    localStorage.setItem("userInfo", JSON.stringify(userInfo));
    this.userInfo = userInfo;
  },
  getUserInfo() { //获取用户信息
    if (this.userInfo) {
      return JSON.parse(JSON.stringify(this.userInfo));
    } else {
      let userInfo = localStorage.getItem("userInfo");
      if (userInfo) {
        this.userInfo = JSON.parse(userInfo);
        return JSON.parse(JSON.stringify(this.userInfo));
      } else {
        return undefined;
      }
    }
  },
  isLogin() { //判断是否登录
    if (this.userInfo) {
      return true;
    }
    return false;
  },
  exitLogin($router, loginTimeOut) { // 退出登录
    localStorage.removeItem("userInfo");
    localStorage.removeItem("menuList");
    localStorage.removeItem("buttonPermissionList");
    this.userInfo = undefined;
    $router.push({
      name: 'login',
      query: {
        loginTimeOut: loginTimeOut ? "1" : "0"
      }
    });
  },
  saveMenuList(menuList) { // 保存菜单列表
    localStorage.setItem("menuList", JSON.stringify(menuList));
    this.menuList = menuList;
  },
  getMenuList() { // 获取菜单列表
    if (this.menuList) {
      return JSON.parse(JSON.stringify(this.menuList));
    } else {
      let menuList = localStorage.getItem("menuList");
      if (menuList) {
        this.menuList = JSON.parse(menuList);
        return JSON.parse(JSON.stringify(this.menuList));
      } else {
        return undefined;
      }
    }
  },
  // 保存按钮权限
  saveButtonPermission(buttonPermissionList) {
    const buttonPermissionMap = new Map();
    buttonPermissionList.forEach((permissionItem) => {
      buttonPermissionMap.set(permissionItem.perms, true);
    });
    localStorage.setItem("buttonPermissionList", JSON.stringify(buttonPermissionList));
    this.buttonPermissionMap = buttonPermissionMap;
  },
  // 校验按钮权限
  checkButtonPermission(perms) {
    return true;
    if (!this.buttonPermissionMap) {
      const buttonPermissionMap = new Map();
      let buttonPermissionList = localStorage.getItem("buttonPermissionList");
      if (buttonPermissionList) {
        buttonPermissionList = JSON.parse(buttonPermissionList);
        buttonPermissionList.forEach((permissionItem) => {
          buttonPermissionMap.set(permissionItem.perms, true);
        });
      }
      this.buttonPermissionMap = buttonPermissionMap;
    }
    return this.buttonPermissionMap.has(perms);
  },
  /**
   * 冒泡排序
   * @param {Object} arr
   */
  bubbleSort(arr, key) {
    let i = arr.length,
      j;
    let tempExchangVal;
    while (i > 0) {
      for (j = 0; j < i - 1; j++) {
        let sort;
        let sort2;
        if (key) {
          sort = arr[j][key];
          sort2 = arr[j + 1][key];
        } else {
          sort = arr[j];
          sort2 = arr[j + 1];
        }
        if (sort > sort2) {
          tempExchangVal = arr[j];
          Vue.set(arr, j, arr[j + 1]);
          Vue.set(arr, j + 1, tempExchangVal);
        }
      }
      i--;
    }
    return arr;
  },
  /**
   * 获取元素距离左边和顶部的位置
   * @param {Object} e
   * @param {Object} type  offsetTop顶部 offsetLeft左边
   * @param {Object} terminationView 遇到该元素的时候不再迭代
   */
  getPosition(e, type, terminationView) {
    let offset = e[type];
    if (e.offsetParent != null && e.offsetParent != terminationView) {
      offset += this.getPosition(e.offsetParent, type, terminationView)
    }
    return offset;
  },
  /**
   * 获取元素的精确数值
   * @param {Object} el
   * @param {Object} key
   */
  getElementBoundingClientRect(el, key) {
    if (key) {
      return el.getBoundingClientRect()[key];
    } else {
      return el.getBoundingClientRect();
    }
  },
  /**
   * 获取多语言列表
   */
  getLanguageList() {
    return JSON.parse(JSON.stringify(languageList));
  },
  /**
   * 获取默认语言
   */
  getDefaultLanguage(language) {
    return "zh-CN";
    if (language) {
      for (let i = 0; i < languageList.length; i++) {
        if (languageList[i].key == language) {
          return language;
        }
      }
    } else {
      let JsSrc = (navigator.language || navigator.browserLanguage).toLowerCase();
      JsSrc = JsSrc.toLowerCase();
      if (JsSrc == "zh-cn") {
        return "zh-CN";
      } else if (JsSrc.indexOf("en") != -1) {
        return "en";
      } else {
        for (let i = 0; i < languageList.length; i++) {
          if (languageList[i].key == JsSrc) {
            return JsSrc;
          }
        }
      }
    }
    return "en";
  },
  /**
   * 时间对象转换成时间格式
   * @param {Object} date
   * @param {Object} splitStr
   */
  dateConversionText(date, splitStr, defaultText) {
    if (date) {
      let M = date.getMonth() + 1;
      let y = date.getFullYear();
      let d = date.getDate();
      let h = date.getHours(); //时
      let m = date.getMinutes(); //分
      let s = date.getSeconds(); //秒

      if (M < 10) M = "0" + M;
      if (d < 10) d = "0" + d;
      if (h < 10) h = "0" + h;
      if (m < 10) m = "0" + m;
      if (s < 10) s = "0" + s;
      if (splitStr == "MM.dd") {
        return M + "." + d;
      } else if (splitStr == "dd") {
        return d;
      } else if (splitStr == "yyyy-MM") {
        return y + "-" + M;
      } else if (splitStr == "yyyy.MM") {
        return y + "." + M;
      } else if (splitStr == "HH:mm") {
        return h + ":" + m;
      } else if (splitStr == "HH:mm:ss") {
        return h + ":" + m + ":" + s;
      } else if (splitStr == "MM.dd HH:mm") {
        return M + "." + d + " " + h + ":" + m;
      } else if (splitStr == "yyyy.MM.dd HH:mm") {
        return y + "." + M + "." + d + " " + h + ":" + m;
      } else if (splitStr == "yyyy-MM-dd HH:mm") {
        return y + "-" + M + "-" + d + " " + h + ":" + m;
      } else if (splitStr == "yyyy-MM-dd HH:mm:ss") {
        return y + "-" + M + "-" + d + " " + h + ":" + m + ":" + s;
      } else if (splitStr == "yyyy.MM.dd") {
        return y + "." + M + "." + d;
      } else if (splitStr == "yyyy-MM-dd") {
        return y + "-" + M + "-" + d;
      } else if (splitStr == "MM.dd HH:mm") {
        return M + "." + d + " " + h + ":" + m;
      } else if (splitStr == "HH:mm") {
        return h + ":" + m;
      } else if (splitStr == "HH:mm:ss_") {
        let str = [];
        if (h != "00") {
          str.push(h);
        }
        str.push(m);
        str.push(s);
        return str.join(":");
      } else if (splitStr == "yyyy年MM月dd日") {
        return y + "年" + M + "月" + d + "日";
      }
    } else {
      return defaultText || "";
    }
  },
  /**
   * 时间格式转化成其他格式
   * @param {Object} timeText
   * @param {Object} splitStr
   */
  timeTextConversionText(timeText, splitStr, defaultText) {
    if (timeText) {
      timeText = timeText.replace(/-/g, "/");
      if (timeText.lastIndexOf(".0") == 19) {
        timeText = timeText.substr(0, 19)
      }
      return this.dateConversionText(new Date(timeText), splitStr);
    } else {
      return defaultText || "";
    }
  },
  /**
   * 时间格式转化成时间戳
   * @param {Object} timeText
   * @param {Object} splitStr
   */
  timeTextConversionTimeStamp(timeText, defaultVal) {
    if (timeText) {
      return Date.parse(new Date(timeText.replace(/-/g, "/")));
    } else {
      return defaultVal == undefined ? 0 : defaultVal;
    }
  },
  /**
   * 时间戳转换成时间格式
   * @param {Object} timeStamp
   * @param {Object} splitStr
   */
  timeStampConversionText(timeStamp, splitStr) {
    if (timeStamp) {
      return this.dateConversionText(new Date(timeStamp), splitStr);
    } else {
      return "";
    }
  },
  guid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      let r = Math.random() * 16 | 0,
        v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  },
  /**
   * 输入框只能输入英文和数字
   * @param {Object} model
   * @param {Object} key
   */
  onInputLettersAndNumbers(model, key) {
    model[key] = model[key].replace(/[^\d|qwertyuiopasdfghjklzxcvbnmQWERTYUIOPASDFGHJKLZXCVBNM]/g, '');
  },
  /**
   * 输入框只能输入数字
   * @param {Object} model
   * @param {Object} key
   */
  onInputNumbers(model, key) {
    model[key] = model[key].replace(/\D+/g, '');
  },
  /**
   * 输入框只能输入数字和小数点
   * @param {Object} model
   * @param {Object} key
   */
  onInputNumbers2(model, key) {
    model[key] = model[key].replace(/[^\d|.]/g, '');
  },
  /**
   * 毫秒转时间格式
   * @param {Object} millisecond
   * @param {Object} type
   */
  millisecondToString(millisecond, type) {
    if (type == "HH:mm") {
      let h = parseInt(millisecond / 3600000);
      let m = parseInt((millisecond % 3600000) / 60000);
      if (h < 10) {
        h = "0" + h;
      }
      if (m < 10) {
        m = "0" + m;
      }
      return h + ":" + m;
    } else if (type == "mm:ss") {
      let m = parseInt(millisecond / 60000) || 0;
      let s = parseInt((millisecond % 60000) / 1000) || 0;
      if (m < 10) {
        m = "0" + m;
      }
      if (s < 10) {
        s = "0" + s;
      }
      return m + ":" + s;
    }
  },
  /**
   * 验证是否是手机号
   * @param {Object} str
   */
  checkMobile(str) {
    let re = /^1\d{10}$/
    if (re.test(str)) {
      return true;
    } else {
      return false;
    }
  },
  /**
   * 验证是否是电话号
   * @param {Object} str
   */
  checkPhone(str) {
    let re = /^0\d{2,3}-?\d{7,8}$/;
    if (re.test(str)) {
      return true;
    } else {
      return false;
    }
  },
  /**
   * 验证是否是邮箱
   * @param {Object} str
   */
  checkEmail(str) {
    let re = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/
    if (re.test(str)) {
      return true;
    } else {
      return false;
    }
  },
  downLoadFile(url, filename) {
    const x = new window.XMLHttpRequest();
    x.open('GET', url, true);
    x.responseType = 'blob';
    x.onload = () => {
      const url = window.URL.createObjectURL(x.response);
      const a = document.createElement('a');
      a.href = url;
      a.target = '_blank'
      a.download = filename;
      a.style.display = 'none'
      document.body.append(a)
      a.click();
    };
    x.send();
  },
  // 压缩图片
  // file : File, option : { size ?: number, maxWidth ?: number, maxHeight ?: number }
  compressImage(file, option) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onerror = () => {
        reject();
      }
      reader.onload = (e) => {
        const image = new Image();
        image.src = e.target.result;
        image.onload = () => {
          let quality = 1;
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          const width = image.width;
          const height = image.height;
          let qualityW = 1;
          if (option.maxWidth && width > option.maxWidth) {
            qualityW = option.maxWidth / width;
            quality = qualityW;
          }
          let qualityH = 1;
          if (option.maxHeight && height > option.maxHeight) {
            qualityH = option.maxHeight / height;
            if (qualityH < quality) {
              quality = qualityH;
            }
          }
          canvas.width = width * quality;
          canvas.height = height * quality;
          ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
          let dataURL = canvas.toDataURL(file.type, quality);
          while (option.size && dataURL.length / 1024 / 1024 > option.size) {
            quality -= 0.1;
            dataURL = canvas.toDataURL(file.type, quality);
          }
          resolve(dataURLtoFile(dataURL, file.name, file.type));
        };
      };
    })
  },
  // 比较两个数组是否相同
  arraysAreEqual(arr1, arr2, key) {
    if (arr1.length !== arr2.length) {
      return false;
    }
    for (let i = 0; i < arr1.length; i++) {
      let isTrue = false;
      for (let j = 0; j < arr2.length; j++) {
        if (key) {
          if (arr1[i][key] == arr2[j][key]) {
            isTrue = true;
            break;
          }
        } else {
          if (arr1[i] == arr2[j]) {
            isTrue = true;
            break;
          }
        }
      }
      if (!isTrue) {
        return false;
      }
    }
    for (let i = 0; i < arr2.length; i++) {
      let isTrue = false;
      for (let j = 0; j < arr1.length; j++) {
        if (key) {
          if (arr2[i][key] == arr1[j][key]) {
            isTrue = true;
            break;
          }
        } else {
          if (arr2[i] == arr1[j]) {
            isTrue = true;
            break;
          }
        }

      }
      if (!isTrue) {
        return false;
      }
    }
    return true;
  },
  setCookie(key, value, expireDate, domain) {
    const expires = new Date();
    if (expireDate) {
      expires.setDate(expires.getDate() + expireDate);
    } else {
      expires.setDate(expires.getDate() + 30);
    }

    Cookies.set(key, value, {
      path: "/",
      expires: expires,
      domain: domain || window.domain,
    })
  },
  // 获取Cookie
  getCookie(key) {
    return Cookies.get(key);
  }
}

//将base64转换为文件对象
function dataURLtoFile(dataurl, filename, type) {
  const arr = dataurl.split(',');
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  //转换成file对象
  return new File([u8arr], filename, {
    type: type
  });
}


// WEBPACK FOOTER //
// ./src/utils/utils.js